var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
const HistoryIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-history", size, className) }, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", x: "0", y: "0", viewBox: "0 0 34 34", role: "img", "aria-label": title },
            React.createElement("title", null, title),
            React.createElement("path", { fill: "currentColor", d: "M29.036 5.029C22.59-1.417 12.312-1.56 5.615 4.456l-1.79-1.79c-.573-.573-1.576-.287-1.755.501l-2.041 8.38a1.077 1.077 0 001.289 1.289l8.38-2.041c.788-.179 1.074-1.182.501-1.755L8.23 7.07c5.264-4.584 13.25-4.441 18.264.573 5.193 5.193 5.193 13.716-.036 18.944l-.501.466c-.752.68-.788 1.826-.143 2.578a1.85 1.85 0 001.361.609c.43 0 .859-.143 1.218-.466.215-.179.43-.394.609-.609 6.659-6.66 6.659-17.475.034-24.136z", role: "presentation" }),
            React.createElement("path", { fill: "currentColor", d: "M22.984 18.745l-4.19-2.686V9.398c0-1.003-.824-1.826-1.826-1.826s-1.826.824-1.826 1.826v7.664c0 .609.322 1.218.859 1.54l5.014 3.187c.286.179.645.286.967.286a1.78 1.78 0 001.54-.859c.536-.824.285-1.934-.538-2.471z", role: "presentation" }),
            React.createElement("circle", { transform: "rotate(-13.286 21.271 31.68)", fill: "currentColor", cx: "21.276", cy: "31.685", r: "1.786", role: "presentation" }),
            React.createElement("circle", { fill: "currentColor", cx: "14.336", cy: "32.149", r: "1.786", role: "presentation" }),
            React.createElement("circle", { fill: "currentColor", cx: "7.896", cy: "29.325", r: "1.786", role: "presentation" }),
            React.createElement("circle", { fill: "currentColor", cx: "3.322", cy: "23.982", r: "1.786", role: "presentation" }))));
};
HistoryIcon.defaultProps = {
    title: "History",
};
export { HistoryIcon };
export default HistoryIcon;
//# sourceMappingURL=History.js.map